import { render, staticRenderFns } from "./MailingModal.vue?vue&type=template&id=5c2db5ba&scoped=true&"
import script from "./MailingModal.vue?vue&type=script&lang=js&"
export * from "./MailingModal.vue?vue&type=script&lang=js&"
import style0 from "./MailingModal.vue?vue&type=style&index=0&id=5c2db5ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2db5ba",
  null
  
)

export default component.exports